import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { Toaster } from './components/common/Toaster';
import { DashboardPage } from './pages/DashboardPage';
import { ChatPage } from './pages/ChatPage';
import { ModelCenterPage } from './pages/ModelCenterPage';
import { SkillCenterPage } from './pages/SkillCenterPage';
import { AgentCenterPage } from './pages/AgentCenterPage';
import { AgentCreatePage } from './pages/AgentCreatePage';
import { KnowledgeBaseCenterPage } from './pages/KnowledgeBaseCenterPage';
import { KnowledgeBaseDetailPage } from './pages/KnowledgeBaseDetailPage';
import { TasksPage } from './pages/TasksPage';
import { HistoryPage } from './pages/HistoryPage';
import { HistorySessionsPage } from './pages/HistorySessionsPage';
import { ChatSessionPage } from './pages/ChatSessionPage';
import { SettingsPage } from './pages/SettingsPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <AppLayout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<DashboardPage data-id="element-4" />} data-id="element-3" />
          <Route path="/chat" element={<ChatPage data-id="element-6" />} data-id="element-5" />
          <Route path="/sessions/:id" element={<ChatPage data-id="element-8" />} data-id="element-7" />
          <Route path="/models" element={<ModelCenterPage data-id="element-10" />} data-id="element-9" />
          <Route path="/skills" element={<SkillCenterPage data-id="element-12" />} data-id="element-11" />
          <Route path="/skills/:id" element={<SkillCenterPage data-id="element-14" />} data-id="element-13" />
          <Route path="/agents" element={<AgentCenterPage data-id="element-16" />} data-id="element-15" />
          <Route path="/agents/new" element={<AgentCreatePage data-id="element-18" />} data-id="element-17" />
          <Route path="/agents/:id/edit" element={<AgentCreatePage data-id="element-20" />} data-id="element-19" />
          <Route path="/knowledge-bases" element={<KnowledgeBaseCenterPage data-id="element-22" />} data-id="element-21" />
          <Route path="/knowledge-bases/:id" element={<KnowledgeBaseDetailPage data-id="element-24" />} data-id="element-23" />
          <Route path="/tasks" element={<TasksPage data-id="element-26" />} data-id="element-25" />
          <Route path="/history-sessions" element={<HistorySessionsPage data-id="element-28" />} data-id="element-27" />
          <Route path="/history/:sessionId" element={<ChatSessionPage data-id="element-30" />} data-id="element-29" />
          <Route path="/history" element={<HistoryPage data-id="element-32" />} data-id="element-31" />
          <Route path="/settings" element={<SettingsPage data-id="element-34" />} data-id="element-33" />
        </Routes>
      </AppLayout>
      <Toaster data-id="element-35" />
    </BrowserRouter>;
}